import React from 'react';
import PropTypes from 'prop-types';
import FilterSelectField from './filterSelect';
import FilterNumberRange from './filterNumberRange';
import FilterCustomAutocomplete from './filterCustomAutocomplete';
import FilterDateRange from './filterDateRange';

const selectList = ['select'];
const numberRangeList = ['numberRange'];
const dateRangeList = ['dateRange'];
const customAutocompleteList = ['custom-multi-autocomplete', 'custom-autocomplete'];

const CustomFilterFormItem = ({ field, onFilterCallback, searchValue = '', filteredParams, isAvailable }) =>
  selectList.includes(field.type) ? (
    <FilterSelectField
      field={field}
      onFilterCallback={onFilterCallback}
      searchValue={searchValue}
      isAvailable={isAvailable}
    />
  ) : numberRangeList.includes(field.type) ? (
    <FilterNumberRange
      field={field}
      onFilterCallback={onFilterCallback}
      filteredParams={filteredParams}
      isAvailable={isAvailable}
    />
  ) : dateRangeList.includes(field.type) ? (
    <FilterDateRange
      field={field}
      onFilterCallback={onFilterCallback}
      filteredParams={filteredParams}
      isAvailable={isAvailable}
    />
  ) : customAutocompleteList.includes(field.type) ? (
    <FilterCustomAutocomplete
      field={field}
      onFilterCallback={onFilterCallback}
      filteredParams={filteredParams}
      searchValue={searchValue}
      multiple={field.type.includes('multi')}
      isAvailable={isAvailable}
    />
  ) : null;

CustomFilterFormItem.propTypes = {
  onFilterCallback: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(Object).isRequired,
  searchValue: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.string]),
  filteredParams: PropTypes.instanceOf(Object).isRequired,
  isAvailable: PropTypes.bool.isRequired,
};

export default CustomFilterFormItem;
